// extracted by mini-css-extract-plugin
module.exports = {"namePadding":"Header-module__namePadding___1V4GA","icon":"Header-module__icon___2TQKa","removeMargin":"Header-module__removeMargin___7x2T5"};